import classNames from "classnames";

import React from "react";

import { Button, ButtonProps } from "react-bootstrap";

import styles from "./BrandButton.module.scss";

interface CustomButtonProps extends ButtonProps {
  icon?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

const BrandButton: React.FC<CustomButtonProps> = ({
  icon,
  className,
  children,
  ...props
}) => {
  const buttonClass = classNames(styles.baseButton, className);

  return (
    <Button className={buttonClass} {...props}>
      {icon && <span className="me-2">{icon}</span>}
      {children}
    </Button>
  );
};

export default BrandButton;
